// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".g-auth-switch-login-tab .g-auth-switch-login-tab__title{line-height:20px;font-size:20px;font-weight:500;height:20px;margin-bottom:12px;text-align:center;font-family:PingFang SC;color:#000}", ""]);
// Exports
module.exports = exports;
